import * as React from "react";
const SvgFiRrCameraRotate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camera-rotate_svg__a)">
      <path
        fill="#062147"
        d="M19 4h-.5l-2.1-2.801A3.02 3.02 0 0 0 14.001 0h-4c-.938 0-1.835.448-2.4 1.2L5.501 4h-.5A5.006 5.006 0 0 0 0 9v10c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V9c0-2.757-2.243-5-5-5M9.199 2.4c.188-.251.488-.4.801-.4h4c.313 0 .612.149.8.399L16 4H8zM22 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM18 9v2c0 1.103-.897 2-2 2h-2a1 1 0 1 1 0-2h.643a4.001 4.001 0 0 0-6.31 1.4 1 1 0 0 1-1.317.516A1 1 0 0 1 6.5 11.6 6 6 0 0 1 12 8c1.492 0 2.913.562 4 1.532V9a1 1 0 1 1 2 0m-.5 7.4A6 6 0 0 1 12 20a6.02 6.02 0 0 1-3.961-1.496V19a1 1 0 1 1-2 0v-2c0-1.103.897-2 2-2H10a1 1 0 1 1 0 2h-.643a4.001 4.001 0 0 0 6.31-1.4 1 1 0 1 1 1.833.8"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camera-rotate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCameraRotate;
